export default __webpack_public_path__ + "static/media/uni.850b2e03.svg";